import { CommonConstants } from '@/constants/common'

function comma(value) {
  return Number(value).toLocaleString();
}

function upperCase(value) {
  return value?.toUpperCase();
}

function unroundedComma(value) {
  return isNaN(value) ? value : value.replace(CommonConstants.UNROUNDED_COMMA_REGEX, ',');
}

export {
  comma,
  upperCase,
  unroundedComma,
}
